/* eslint-disable max-len */
import twentyFourHourAccessIcon from 'assets/images/storage-basics/wte-icon--24-hour-access.png';
import climateControlledontrolIcon from 'assets/images/storage-basics/wte-icon--climate-control.png';
import driveUpAccessIcon from 'assets/images/storage-basics/wte-icon--drive-up-access.png';
import locksIcon from 'assets/images/storage-basics/wte-icon--locks.png';
import securityIcon from 'assets/images/storage-basics/wte-icon--security.png';
import truckRentalIcon from 'assets/images/storage-basics/wte-icon--truck-rental.png';

import parkimgImage from 'assets/images/size-guide/unit--parking.png';
import rvImage from 'assets/images/size-guide/unit--rv.png';
import lockerImage from 'assets/images/size-guide/unit--locker.png';
import workspaceImage from 'assets/images/size-guide/unit--workspace.png';

export const unitAmenities = [
	{
		title: 'Climate Control',
		buttonText: 'Climate Control',
		description:
			'The facility will maintain a safe temperature and humidity level for your unit. If you’re storing something temperature-sensitive or particularly valuable, climate control is a good idea.',
		search: 'climateControlled',
		image: climateControlledontrolIcon,
	},
	{
		title: 'Drive-Up Access',
		buttonText: 'Drive-Up Access',
		description:
			'You can pull your moving truck or vehicle right up to the unit. This is rarely available for indoor units.',
		search: 'driveUp',
		image: driveUpAccessIcon,
	},
	{
		title: 'Truck Rental',
		buttonText: 'Truck Rental',
		description:
			'Some facilities will let you rent their moving truck for free. Specific terms and restrictions will vary by facility (e.g., mileage limits, time limits, insurance requirements, refueling protocol).',
		search: 'freeTruckRental',
		image: truckRentalIcon,
	},
	{
		title: '24-Hour Access',
		buttonText: '24-Hour Access',
		description:
			'You have access to your unit at any time. Restrictions may apply—for example, your facility could require manager approval. Some facilities only allow business customers 24-hour access or may charge additional fees.',
		search: 'twentyFourHourAccess',
		image: twentyFourHourAccessIcon,
	},
	{
		title: 'Locks',
		buttonText: 'Secure',
		description:
			'Most facilities require you to bring your own lock, although many will sell locks onsite. We recommend closed-shackle padlocks, disc locks or cylinder locks. Standard or combination padlocks are easily picked and not recommended.',
		search: 'alarm',
		image: locksIcon,
	},
	{
		title: 'Security',
		buttonText: 'Secure',
		description:
			'Video camera surveillance, electronic gates and “fenced + lighted” can all increase the security of the facility. A manager who lives onsite means that someone will be on the premises during non-business hours.',
		search: 'alarm',
		image: securityIcon,
	},
];

export const vehicleUnitSizes = [
	{
		title: "10' x 10'",
		willFit: 'Motorcycles or very small cars',
		image: parkimgImage,
		sqft: 100,
		className:'img-w88',
	},
	{
		title: "10' x 15'",
		willFit: 'Vehicles under 15 feet in length',
		image: parkimgImage,
		sqft: 150,
		className:'img-w88'
	},
	{
		title: "10' x 20'",
		willFit: 'Most average-sized vehicles',
		image: parkimgImage,
		sqft: 200,
		className:'img-w88'
	},
	{
		title: "10' x 30'",
		willFit: 'Most vehicles, trucks or vans',
		image: rvImage,
		sqft: 300,
		className:'img-w91'
	},
];

export const specialUnitSizes = [
	{
		title: 'Storage Lockers',
		description:
			'Storage lockers have ceiling heights ranging from two to five feet (ideal if you’re only storing a few boxes and bags)',
		image: lockerImage,
	},
	{
		title: 'Mezzanine Units',
		description:
			'Mezzanine units are locker-sized units located above other lockers or full-sized units. They are usually accessed via ladder.',
		image: lockerImage,
	},
	{
		title: 'Workspaces',
		description:
			'Workspaces are designed for office or commercial use, and unfit for everyday storage. They are often climate-controlled with electrical outlets.',
		image: workspaceImage,
	},
];
